import { Clock } from "./Clock";


export interface IUpdateClockPopup{
    show(clock_to_update:Clock): Promise<any | null>
    close(result)
}

export class UpdateClockPopup implements IUpdateClockPopup{
    showed: boolean;
    clock_to_update:Clock
    errors;
    resolve_prom;

    constructor() {
        this.showed = false;
        this.errors = {}
    }

    show(clock_to_update:Clock) {
        this.clock_to_update = clock_to_update.clone()
        this.showed = true;
        return new Promise((resolve) => {
            this.resolve_prom=resolve
          })
    }
    close(result) {
        if(result && !result.justification){
            this.errors={'justification' :'El campo justificación es obligatorio'}
        }
        else{
            this.errors = {}
            this.showed = false;
            this.resolve_prom(result)
        }

    }
}